var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", sm: "4" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", sm: "4" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", sm: "4" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mt-4 mb-3", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", width: "100%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }